import styled, { css } from 'styled-components';
import Link from 'Elements/Link';

export const Wrapper = styled.li<{ $active: boolean; $colour: string }>`
    ${({ theme, $active, $colour }) => css`
        min-width: 90%;
        margin: 1.25rem 0.5rem;
        background: ${theme.colors.background.hex};
        border-radius: 0.5rem;
        display: flex;
        flex-direction: column;
        transform: translateZ(0);

        &:hover {
            outline: ${theme.commonStyles.brandPixel} solid ${$colour};
        }

        ${$active &&
        css`
            background: ${theme.colors.tertiary.hex};
            color: ${theme.colors.tertiaryContrast.hex};
            outline: 0.175rem solid ${$colour};
        `}

        @media ${theme.breakpoints.mediumSmall.media} {
            min-width: 22.5rem;
        }

        @media ${theme.breakpoints.large.media} {
            margin: 1.25rem 0 0;
        }

        @media ${theme.breakpoints.xlarge.media} {
            width: auto;
            flex-direction: row;
        }
    `}
`;

export const ThumbnailWrapperDefault = styled.div`
    ${({ theme }) => css`
        display: none;

        @media ${theme.breakpoints.xlarge.media} {
            display: block;
            position: relative;
            height: 6.5rem;
            border-radius: 0.5rem 0.5rem 0 0;
            overflow: hidden;
            height: auto;
            min-width: 10rem;
            max-height: 100%;
            border-radius: 0.5rem 0 0 0.5rem;
            transform: translateZ(0);
        }
    `}
`;

export const ThumbnailWrapperMobile = styled.div`
    ${({ theme }) => css`
        position: relative;
        height: 6.5rem;
        border-radius: 0.5rem 0.5rem 0 0;
        transform: translateZ(0);
        overflow: hidden;

        @media ${theme.breakpoints.xlarge.media} {
            display: none;
        }
    `}
`;

export const Inner = styled.div`
    ${({ theme }) => css`
        position: relative;
        padding: 0.75rem 1rem 2.5rem;
        flex-grow: 1;

        @media ${theme.breakpoints.large.media} {
            padding: 0.75rem 1rem;
        }
    `}
`;

export const Name = styled.h3`
    font-size: 1.5rem;
    margin: 0;
    display: inline-block;
`;

export const StyledLink = styled(Link)`
    all: inherit;
    cursor: pointer;

    &:hover,
    &:focus {
        text-decoration: underline;
    }
`;

export const Address = styled.p`
    ${({ theme }) => css`
        margin: 0;
        font-size: 1rem;
        line-height: 1.1;
        color: ${theme.colors.secondary.tints[3].hex};
    `}
`;

export const Excerpt = styled.p`
    margin: 0.5rem 0;
    font-size: 1.125rem;
    line-height: 1.2;
`;

export const Details = styled.div`
    ${({ theme }) => css`
        display: flex;
        justify-content: space-between;
        position: absolute;
        bottom: 0.75rem;
        left: 0;
        padding: 0 1rem;
        width: 100%;

        @media ${theme.breakpoints.large.media} {
            position: relative;
            bottom: auto;
            padding: 0;
        }
    `}
`;

export const Detail = styled.div`
    display: flex;
    align-items: center;
`;

export const DetailIconCalendar = styled.svg`
    ${({ theme }) => css`
        width: 1.5rem;
        color: ${theme.colors.secondary.tints[3].hex};
    `}
`;

export const DetailIconWalking = styled.svg`
    ${({ theme }) => css`
        width: 0.75rem;
        color: ${theme.colors.secondary.tints[3].hex};
    `}
`;

export const DetailText = styled.span`
    ${({ theme }) => css`
        margin: 0 0 0 0.5rem;
        font-size: 1rem;
        font-weight: 300;
        line-height: 1.1;
        color: ${theme.colors.secondary.tints[3].hex};
    `}
`;
